import { isFeatureEnabled } from '../../utils/feature-flags';
import { useUserSettings } from '../../utils/use-user-settings';
import { useSupportAgentVisibility } from './support-agent-visibility';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

export default function SupportAgentNavToggle() {
  const { features } = useUserSettings();
  const { visible, toggleVisible } = useSupportAgentVisibility();

  if (!isFeatureEnabled('supportAgentEnabled', features ?? null)) {
    return null;
  }

  return (
    <Tooltip
      title={visible ? 'Hide Support Agent' : 'Show Support Agent'}
      arrow
    >
      <IconButton
        onClick={toggleVisible}
        color={visible ? 'primary' : 'default'}
        aria-label={visible ? 'Hide Support Agent' : 'Show Support Agent'}
        aria-pressed={visible}
        data-testid="support-agent-nav-toggle"
      >
        <SupportAgentIcon />
      </IconButton>
    </Tooltip>
  );
}
